import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import DashboardLayout from "src/layouts/DashboardLayout";
import HomeLayout from "src/layouts/HomeLayout";
import LoginLayout from "src/layouts/LoginLayout";

export const routes = [
  // {
  //   exact: true,
  //   path: "/",
  //   component: lazy(() => import("src/views/auth/Main")),
  // },
  {
    exact: true,
    path: "/",
    layout: LoginLayout,
    component: lazy(() => import("src/views/auth/LogIn")),
  },
  {
    exact: true,
    path: "/login",
    layout: LoginLayout,
    component: lazy(() => import("src/views/auth/LogIn")),
  },
  {
    exact: true,
    path: "/signup",
    layout: LoginLayout,
    component: lazy(() => import("src/views/auth/signup/signup")),
  },

  {
    exact: true,
    path: "/dashboard",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/Dashboard")),
  },

  {
    exact: true,
    path: "/stake-details",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/StakingDetails/Index")),
  },
  {
    exact: true,
    path: "/welcome",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/Welcome")),
  },
  {
    exact: true,
    path: "/edit-profile",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/Editprofile/index")),
  },
  // {
  //   exact: true,
  //   path: "/edit-profile",
  //   // guard:true,
  //   layout: DashboardLayout,
  //   component: lazy(() => import("src/views/pages/Editprofile/index")),
  // },

  {
    exact: true,
    path: "/roadmap",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/views/auth/Main/Roadmap")),
  },
  // {
  //   exact: true,
  //   path: "/payment-gateway",
  //   // guard:true,
  //   layout: DashboardLayout,
  //   component: lazy(() => import("src/views/pages/PaymentGateWay/index")),
  // },
  // {
  //   exact: true,
  //   path: "/trade",
  //   // guard:true,
  //   layout: DashboardLayout,
  //   component: lazy(() => import("src/views/pages/Trade/")),
  // },
  {
    exact: true,
    path: "/bank-details",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/BankDetails")),
  },
  {
    exact: true,
    path: "/my-wallet",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/Dashboard/index")),
  },
  {
    exact: true,
    path: "/transaction-history",
    // guard:true,
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/TransactionHistory/")),
  },

  {
    exact: true,
    path: "/my-wallet/approve",
    // guard:true,
    // layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/MyWallet/Approve")),
  },
  {
    exact: true,
    path: "/dashboard/approve",

    component: lazy(() => import("src/views/pages/MyWallet/Approve")),
  },
  {
    exact: true,
    path: "/token/approve",
    component: lazy(() => import("src/views/pages/MyWallet/Approve")),
  },
  {
    exact: true,
    path: "/my-wallet/approve-nml",
    // guard:true,
    // layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/MyWallet/ApproveNML")),
  },
  {
    exact: true,
    path: "/dashboard/approve-nml",

    component: lazy(() => import("src/views/pages/MyWallet/ApproveNML")),
  },
  {
    exact: true,
    path: "/token/approve-nml",
    component: lazy(() => import("src/views/pages/MyWallet/ApproveNML")),
  },
  {
    exact: true,
    path: "/notifications",
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/notifications/index")),
  },
  {
    exact: true,
    path: "/notification-detail",
    layout: DashboardLayout,
    component: lazy(() =>
      import("src/views/pages/notifications/NotificationDetails")
    ),
  },
  {
    exact: true,
    path: "/faq",
    component: lazy(() => import("src/views/pages/faq/index")),
  },
  {
    exact: true,
    path: "/Fauth",
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/2FA/index")),
  },
  {
    exact: true,
    path: "/add-kyc",
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/KYC")),
  },
  {
    exact: true,
    path: "/kyc",
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/KYC/KycList")),
  },
  {
    exact: true,
    path: "/token",
    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/Token/")),
  },
  {
    exact: true,
    path: "/terms",
    // layout: HomeLayout,
    component: lazy(() => import("src/views/pages/termsmain")),
  },
  {
    exact: true,
    path: "/support",
    // layout: HomeLayout,
    component: lazy(() => import("src/views/pages/Support")),
  },
  {
    exact: true,
    path: "/aboutus",
    // layout: HomeLayout,
    component: lazy(() => import("src/views/pages/AboutUsmain")),
  },
  {
    exact: true,
    path: "/privacy-policy",
    // layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/privacymain")),
  },
  {
    exact: true,
    path: "/user-info",

    layout: DashboardLayout,
    component: lazy(() => import("src/views/pages/user-info/index")),
  },
  {
    exact: true,
    path: "/forget-password",

    layout: LoginLayout,
    component: lazy(() => import("src/views/auth/forget-password/index")),
  },
  {
    exact: true,
    path: "/instrauctions",

    component: lazy(() => import("src/views/auth/forget-password-link/index")),
  },
  {
    exact: true,
    path: "/verify-otp",

    layout: LoginLayout,
    component: lazy(() =>
      import("src/views/auth/forget-password-link/OtpVerify")
    ),
  },
  {
    exact: true,
    path: "/verify-email-otp",

    layout: LoginLayout,
    component: lazy(() => import("src/views/auth/signup/VerifyEmailOtp")),
  },
  {
    exact: true,
    path: "/verify-phone-otp",

    layout: LoginLayout,
    component: lazy(() => import("src/views/auth/signup/PhoneVerification")),
  },
  {
    exact: true,
    path: "/reset-password",

    layout: LoginLayout,
    component: lazy(() => import("src/views/auth/reset-password/index")),
  },

  {
    exact: true,
    path: "/buy",
    component: lazy(() => import("src/views/pages/Trade/Buy/")),
  },
  {
    exact: true,
    path: "/sell",
    component: lazy(() => import("src/views/pages/Trade/Sell/")),
  },
  {
    exact: true,
    path: "/contact-us",

    layout: LoginLayout,
    component: lazy(() => import("src/views/pages/ContactUs")),
  },
  {
    exact: true,
    path: "/news-letter",

    layout: DashboardLayout,

    component: lazy(() => import("src/views/pages/NewsLetter")),
  },
  {
    exact: true,
    path: "/view-kyc",

    layout: DashboardLayout,

    component: lazy(() => import("src/views/pages/KYC/KycView")),
  },
  {
    exact: true,
    path: "/white-paper",

    layout: DashboardLayout,

    component: lazy(() => import("src/views/pages/whitepapper/WhitePaper")),
  },
  // {
  //   exact: true,
  //   path: "/currency",
  //   // guard:true,
  //   layout: DashboardLayout,
  //   component: lazy(() => import("src/views/pages/Currency/")),
  // },
  {
    exact: true,
    path: "/404",
    component: lazy(() => import("src/views/errors/NotFound")),
  },
  {
    component: () => <Redirect to="/404" />,
  },
];
